import { PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import { NativeUtils } from '../../native/native.utils';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { IGeolocation } from '../../geolocation/models/IGeolocation';
import { LoaderManager } from '../../../loaders/LoaderManager';

export class InitGeolocationFlowPostLoginAction extends PostLoginActionBase {
    private get _geolocationPromise(): Promise<IGeolocation> {
        return LoaderManager.Instance.GeolocationLoader.Instance;
    }

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.InitGeolocationFlow,
            'InitGeolocationFlowPostLogionAction',
            state,
        );
    }

    protected override doAction = async (): Promise<void> => {
        NativeUtils.showBottomBar(false);
        const geolocation = await this._geolocationPromise;
        if (geolocation) geolocation.init();
        else this.completeAction();
    };
}
